import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function ProblemSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section ref={ref} className="w-full bg-[#F5EDE4] px-4 py-16 md:py-24" data-id="element-144">
      <div className="max-w-3xl mx-auto" data-id="element-145">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6
      }} data-id="element-146">
          <h2 className="text-3xl md:text-4xl font-bold text-[#3D2B1F] text-center mb-10 leading-tight" data-id="element-147">
            El Problema
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.15
      }} className="bg-white/80 rounded-2xl p-6 md:p-10 shadow-sm shadow-[#3D2B1F]/5 mb-8" data-id="element-148">
          <p className="text-lg leading-relaxed text-[#5C4A3A] mb-5" data-id="element-149">
            La mayoría de los padres hispanos en Estados Unidos viven atrapados
            en una <strong className="text-[#3D2B1F]" data-id="element-150">guerra interna</strong>.
          </p>
          <p className="text-lg leading-relaxed text-[#5C4A3A] mb-5" data-id="element-151">
            Por un lado, la crianza con la que crecimos — gritos y castigos — ya
            no se siente bien y nos llena de{' '}
            <span className="text-[#C44B4B] font-semibold" data-id="element-152">culpa</span>. Por
            otro lado, la "crianza moderna" a veces parece demasiado suave y
            lenta para el mundo real.
          </p>
          <p className="text-lg leading-relaxed text-[#5C4A3A]" data-id="element-153">
            El resultado es{' '}
            <strong className="text-[#3D2B1F]" data-id="element-154">agotamiento extremo</strong>.
            Llegas tarde del trabajo, cansado, y te encuentras con una falta de
            respeto o un berrinche que se lleva tu última gota de energía.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col sm:flex-row gap-4" data-id="element-155">
          {/* Option 1 - Explode */}
          <div className="flex-1 bg-[#FDEAEA] rounded-xl p-5 border border-[#C44B4B]/15" data-id="element-156">
            <div className="text-2xl mb-2" data-id="element-157">💥</div>
            <p className="text-[#3D2B1F] font-semibold mb-1" data-id="element-158">Opción A:</p>
            <p className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-159">
              Explotar y sentir la culpa devorándote toda la noche.
            </p>
          </div>

          {/* Option 2 - Activate */}
          <div className="flex-1 bg-[#E8F0E4] rounded-xl p-5 border border-[#7B9E6B]/20" data-id="element-160">
            <div className="text-2xl mb-2" data-id="element-161">🧠</div>
            <p className="text-[#3D2B1F] font-semibold mb-1" data-id="element-162">Opción B:</p>
            <p className="text-[#5C4A3A] text-base leading-relaxed" data-id="element-163">
              Activar un interruptor biológico que te devuelve el control para
              actuar con firmeza y calma.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}